import { Text, NakedButton } from '@qga/roo-ui/components';
import MessageBoard from 'components/MessageBoard';

const CancellationPolicyMessageBoard = ({ onClickCancellationPolicy, ...styleProps }) => {
  return (
    <MessageBoard py={4} {...styleProps}>
      <Text fontSize="base" fontWeight="normal">
        Please review the{' '}
        <NakedButton textDecoration="underline" onClick={onClickCancellationPolicy}>
          cancellation policy
        </NakedButton>{' '}
        as it has now changed.
      </Text>
    </MessageBoard>
  );
};

export default CancellationPolicyMessageBoard;
